import React, { useState, useEffect } from 'react';
import PropTypes, { string, number } from 'prop-types';
import { CardContent, CardTitle, Button, Image } from '@thd-olt-component-react/core-ui';
import { Price } from '@thd-olt-component-react/price';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ApplyNowModal } from '../apply-now-modal/apply-now-modal.component';
import { clickEvent, impressionEvent, productClickEvent } from '../publisher';
import { cardImageUrl, defaultApplyNowLink } from '../plccUtils';
import { getPaymentEstimatorDetails, loadEstimatorScript, getUserName } from '../utils';
import './product-spotlight.style.scss';

const ProductSpotlight = ({ paymentEstimatorVersion, isMobile, product }) => {
  const [paymentEstimatorDetails, setPaymentEstimatorDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const price = product.price;
  const productPricing = product;
  productPricing.pricing = { value: product.price };
  const productImage = product.imageURL.replace('<SIZE>', '300');
  const isAppliance = product.itemType === 'MAJOR_APPLIANCE';
  const productName = product.brand + ' ' + product.productName;
  const cardTitle = getUserName() ? getUserName() + ', More Ways to Pay' : 'More Ways to Pay';

  const redirectToProduct = () => {
    productClickEvent();
    window.location.href = window.location.hostname + product.canonicalURL;
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const analyticsInteraction = () => {
    clickEvent('plcc-apply now-personalized', 'card');
  };

  useEffect(() => {
    loadEstimatorScript(
      paymentEstimatorVersion,
      () => setPaymentEstimatorDetails(getPaymentEstimatorDetails(price, isMobile, isAppliance, false, 'homepage'))
    );
    impressionEvent('plcc-apply now-personalized');
  }, []);

  const {
    applyNowUrl, displayPrice, promotionTerm,
  } = paymentEstimatorDetails || {};

  const applyNowMessage = () => {
    return (
      <>
        <div className="product-spotlight-grid u--paddingBottom">
          <Image
            src={productImage}
            className="product-spotlight-image"
            alt={productName}
            width="100"
            onClick={redirectToProduct}
          />
          <div className="product-spotlight-description" onClick={redirectToProduct} role="link" tabIndex={0}>
            <div className="product-spotlight-name">
              {productName}
            </div>
            <QueryProvider cacheKey="innerQuery">
              <Price
                product={productPricing}
                large={false}
                displayEachUom={false}
                itemId="123456789"
              />
            </QueryProvider>
          </div>
          <Image
            src="https://assets.thdstatic.com/images/v1/plus-orange.svg"
            className="u--padding product-spotlight-plus"
            alt="plus"
            width="20"
          />
          <Image
            src={cardImageUrl.PLCN_HOMEDEPOT}
            className="product-spotlight-card-image"
            alt="Credit Card Icon"
            height="50"
            width="80"
          />
          <div className="product-spotlight-financing-message">
            <span className="u__bold">${displayPrice}.00 per mo.* </span>suggested
            payments with <span className="u__bold">{promotionTerm} months* </span>financing
            on this <span className="u__bold">${price} </span>purchase
          </div>
        </div>
        <div className="u--paddingTop u--paddingBottom">
          <Button tag="a" href={applyNowUrl} onClick={analyticsInteraction} outline dark>
            Apply Now
          </Button>
        </div>
      </>
    );
  };

  return (
    <>
      <CardTitle title={cardTitle} />
      <CardContent>
        {showModal && (
          <ApplyNowModal
            applyNowUrl={applyNowUrl}
            closeModal={closeModal}
            price={price}
            isMobile={isMobile}
            monthlyPayment={displayPrice}
            promotionTerm={promotionTerm}
            analyticsFeature="plcc-est-bundle"
          />
        )}
        <div className="product-spotlight">
          {applyNowMessage()}
          <p className="u__text-align--center">
            See{' '}
            <button
              className="u__default-link legal-click"
              onClick={openModal}
              type="button"
            >
              Terms & Conditions
            </button>{' '}
            for offer details.
          </p>
        </div>
      </CardContent>
    </>
  );
};

ProductSpotlight.propTypes = {
  paymentEstimatorVersion: PropTypes.string,
  isMobile: PropTypes.bool,
  product: PropTypes.shape({
    productName: string.isRequired,
    brand: string.isRequired,
    canonicalURL: string.isRequired,
    imageURL: string.isRequired,
    itemType: string.isRequired,
    price: number.isRequired,
  }).isRequired
};
ProductSpotlight.defaultProps = {
  paymentEstimatorVersion: 'v1.0.40',
  isMobile: false,
};

export default ProductSpotlight;
